import { useInViewport, useMount, useUnmount } from "ahooks";
import { useEffect, useState } from "react";
type UseInViewOptions = IntersectionObserverInit;

let timer: NodeJS.Timeout;
const useInViewportLoad = (target, options?: UseInViewOptions, delay: number = 300) => {
  const [hasBeenInView, setHasBeenInView] = useState(false);
  const [isMount, setIsMount] = useState(false);

  const [inViewport] = useInViewport(target, (options = {}));
  useEffect(() => {
    if (hasBeenInView) return;
    if (!isMount) return;
    if (inViewport) {
      setHasBeenInView(true);
    }
  }, [inViewport]);

  useMount(() => {
    timer = setTimeout(() => {
      setIsMount(true);
    }, delay);
  });
  useUnmount(() => {
    clearTimeout(timer);
  });

  return [hasBeenInView] as const;
};

export default useInViewportLoad;
